import { cloneDeep } from 'lodash'
import { Data } from './types'

export const findParentID = (categories: Data[], id: number): number => {
  let parentID = 0 as any
  for (let i = 0; i < categories.length; i++) {
    if (categories[i].id === id) {
      parentID = categories[i].parent_id
      return parentID
    } else {
      const child = categories[i]?.child || []
      for (let j = 0; j < child.length; j++) {
        if (child[j].id === id) {
          parentID = child[j].parent_id
          return parentID
        }
      }
    }
  }

  return parentID
}

export const filterData = (categories: Data[], filter: number[]): Data[] => {
  if (filter.length <= 0) return categories
  const groupId = (filter && filter[0]) || 0
  const cateId = (filter && filter[1]) || 0
  const subCateId = (filter && filter[2]) || 0

  const group = (groupId && categories.filter((group: Data) => group.id === groupId)) || []
  const result = cloneDeep(group)
  if (result && cateId) {
    result.map((group: Data) => {
      group.child = group.child?.filter((cate: Data) => cate.id === cateId)
      return group
    })
  }
  if (result && subCateId) {
    result.map((group: Data) => {
      return group?.child?.map((cate: Data) => {
        cate.child = cate?.child?.filter((subcate: Data) => subcate.id === subCateId)
        return cate
      })
    })
  }

  return result
}
